import type { DOMOutputSpec, Node as ProsemirrorNode, NodeSpec } from 'prosemirror-model';

import { ChecklistStyles } from './checklist-styles';
import { cssStyleDeclarationToString } from '../../../helpers/utils';
import { NodeName } from '../../../schema/nodes';

export class ChecklistNode implements NodeSpec {
  public static readonly nodeName = NodeName.Checklist;
  public static is(node: ProsemirrorNode) {
    return node.type.name === ChecklistNode.nodeName;
  }

  public content = 'checklist_item+';
  public group = 'block';
  public parseDOM = [
    {
      tag: 'ol[data-component-type="checklist"]',
    },
  ];

  constructor(checklistViewOnly: boolean) {
    if (checklistViewOnly) {
      this.parseDOM = [];
    }
  }

  public toDOM = (): DOMOutputSpec => [
    'ol',
    {
      'data-component-type': 'checklist',
      style: cssStyleDeclarationToString(ChecklistStyles.getBaseStyles()),
    },
    0,
  ];
}
